import React from "react";

import IntentFragment, { IntentFragmentProps } from "./intent/IntentFragment";
import SentenceForm, { SentenceFormProps } from "./sentence/SentenceForm";
import SentenceFragment, { SentenceFragmentProps } from "./sentence/SentenceFragment";


export type IntentTableRowFactoryProps =
    | (IntentFragmentProps & { type: 'intent' })
    | (SentenceFragmentProps & { type: 'sentence' })
    | (SentenceFormProps & { type: 'sentence-edit' })

const IntentTableRowFactory: React.FC<IntentTableRowFactoryProps> = (props) => {
    switch (props.type) {
        case 'intent':
            return <IntentFragment {...(props as IntentFragmentProps)} />;
        case 'sentence':
            return <SentenceFragment {...(props as SentenceFragmentProps)} />;
        case 'sentence-edit':
            return <SentenceForm {...(props as SentenceFormProps)} />;
        default:
            return null;
    }
};

export default IntentTableRowFactory;
